import React from "react"
import { createUseStyles } from 'react-jss'
import RecipeSection from "./RecipeSection"
import SubmitButton from "./SubmitButton"

const useStyles = createUseStyles({
    container: {
        paddingLeft: '80px',
        paddingRight: '80px'
    }
})

const RecipeForm = (props) => {
    const {recipe, buttonText} = props
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <RecipeSection name="Title" isList={false} value={recipe.title} maxRows={1}/>
            <RecipeSection name="Ingredients" isList={true} value={recipe.ingredients}/>
            <RecipeSection name="Steps" isList={true} value={recipe.steps}/>
            <RecipeSection name="Notes" isList={false} value={recipe.notes}/>
            <SubmitButton text={buttonText}/>
        </div>
    );
}

export default RecipeForm
